var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trustpilot-block" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "trustpilot-block__text" },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "trustpilot-block__widget" }),
    _vm._v(" "),
    _c("div", { staticClass: "trustpilot-block__cta" }, [
      _c("button", {
        staticClass: "btn btn--positive",
        domProps: { textContent: _vm._s(_vm.translations.search_btn_txt) },
        on: { click: _vm.scrollToTop }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "trustpilot-block__header" }, [
      _c("img", {
        staticClass: "trustpilot-block__image",
        attrs: {
          src: require("../../../../assets/img/trustpilot-block.svg"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "trustpilot-block__skovrejser-logo",
        attrs: {
          src: require("../../../../assets/img/logos/skov-rejser-dk-logo-purple.webp"),
          alt: "Skovrejser.dk logo"
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c597f6a4", { render: render, staticRenderFns: staticRenderFns })
  }
}